<template>
  <div>
    <base-button @click="isVisible = !isVisible">
      <img src="~icons/security/safedeal-gradient.svg" alt="" />
    </base-button>

    <base-dialog v-model="isVisible">
      <dialog-template>
        <div
          slot="title"
          v-text="$t('safe.deal.service.title')"
        ></div>

        <div
          slot="content"
          :class="$style.content"
        >
          <p v-text="$t('safe.deal.service.security')"></p>
          <p v-text="$t('safe.deal.service.information')"></p>
          <p v-text="$t('safe.deal.service.notification')"></p>
          <p
            v-if="confirmationCountDays"
            v-html="$t('safe.deal.service.confirmation', { days: pluralizedDays })"
          ></p>
          <p
            v-else
            v-text="$t('safe.deal.service.close')"
          ></p>
        </div>

        <div
          slot="footer"
          v-grow
          :class="$style.footer"
        >
          <simple-button @click="isVisible = false">
            {{ $t('dialog.button.clear') }}
          </simple-button>
        </div>
      </dialog-template>
    </base-dialog>
  </div>
</template>

<script>
import BaseButton from 'atoms/base/BaseButton';
import BaseDialog from 'molecules/base/Dialog';
import SimpleButton from 'molecules/common/SimpleButton';
import DialogTemplate from 'templates/DialogTemplate';

export default {
  name: 'ProjectSafeDeal',
  components: {
    BaseButton,
    BaseDialog,
    SimpleButton,
    DialogTemplate,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    confirmationCountDays() {
      return this.project.safeDealConfirmationDays ?? null;
    },
    pluralizedDays() {
      return this.$tc('pluralize.days', this.confirmationCountDays);
    },
  },
};
</script>

<style lang="sass" module>
  .content
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff

    p
      opacity: .75

      &:not(:last-child)
        margin-bottom: 20px

    strong
      font-weight: 700

  .footer
    +flexbox
    +justify-content(center)

    +respond-to('small')
      margin: 0 95px
</style>
